import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.departamento.fields.id'),
  },
  {
    name: 'nombre',
    label: i18n('entities.departamento.fields.nombre'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.departamento.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.departamento.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
